export default {
    apiKey: 'AIzaSyCbBUwUT7vSzo4SfV7YmuuPtJunv2o6dt0',
    authDomain: 'metafashion-us.firebaseapp.com',
    databaseURL: 'https://metafashion-us.firebaseio.com',
    storageBucket: 'metafashion-us.appspot.com',
    messagingSenderId: '1089048796876',
    projectId: 'metafashion-us',
}
